import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import avtar5 from '../../assets/images/user/avatar-5.jpg'
import { getData } from '../Services/api'

const ViewTesti = () => {
  const {id} = useParams();
    const [values, setValues] = useState({
        name: "",
        rating: "",
        review: "",
        purchased_item: "",
        avatar: null,
    })

    const fetchTestimonials = async () => {
        try {
            const res = await getData(`/testimonials/${id}`);
            if (res.status) {
                setValues(res.data || {})
            }
        } catch (error) {
            console.log("error fetch testimonials", error)
        }
    }

    useEffect(() => {
        fetchTestimonials();
    }, [id])

    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/testimonials/testimonial-list">Testimonials</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Testimonial Details
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">Testimonial Details</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Testimonials Details</h5>
                                </div>
                                <div className="card-body">
                                    <form >
                                        <div className="row">
                                            <div className="col-sm-12 mb-3">
                                                <label htmlFor="avatar" className="form-label">
                                                    Testimonial Image
                                                </label>
                                                {values.avatar && (
                                                    <img
                                                        src={values?.avatar ? `${values.avatar}` : avtar5}
                                                        alt="Preview"
                                                        className="img-fluid mt-2"
                                                        style={{ maxWidth: "150px", borderRadius: "8px" }}
                                                    />
                                                )}
                                            </div>

                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">User Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter User Name"
                                                        name='name'
                                                        value={values.name}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Rating</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder="Enter Rating"
                                                        name='rating'
                                                        value={values.rating}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Total Purchase Item</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder="Enter Rating"
                                                        name='purchased_item'
                                                        value={values.purchased_item}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">review</label>
                                                    <div className='border p-3 rounded' dangerouslySetInnerHTML={{ __html: values.review }} />
                                                </div>
                                            </div>
                                        </div>
                                    </form >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ViewTesti